export default __webpack_public_path__ + "assets/images/d06ed520f3553187e77386b70722403c.jpg";